<template>
    <el-container style="height: 100vh;">
      <!-- 顶部栏 -->
      <el-header class="top-header" style="height: 60px; line-height: 60px; padding: 0 20px; display: flex; justify-content: space-between; align-items: center;">
        <!-- 左侧Logo -->
        <div style="display: flex; align-items: center;">
          <img src="@/assets/login-logo.png" alt="logo" style="width: 180px; margin-right: 0px;">
          <h2 style="margin: 0; color: #1f2d3d; font-size: 22px;">瑞盖赛事管理平台</h2>
        </div>
        <!-- 右侧个人中心（引入Header组件） -->
        <Header />
      </el-header>
  
      <el-container>
        <!-- 左侧菜单 -->
        <el-aside width="200px" style="background: #2e3b4e; height: calc(100vh - 60px);">
          <Sidebar />
        </el-aside>
  
        <!-- 右侧主体区域 -->
        <el-main style="padding: 20px; background: #f5f5f5; height: calc(100vh - 60px); overflow: auto;">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </template>
  
  <script>
  import Header from './Header'
  import Sidebar from './Sidebar'
  
  export default {
    name: 'Layout',
    components: {
      Header,
      Sidebar
    }
  }
  </script>
  
  <style scoped>
  .top-header{
    border-radius: 0; /* 顶部栏一般通栏，圆角设0 */
    box-shadow: 0 1px 2px rgba(0,0,0,0.05); /* 轻微阴影增加层次感 */
    background: linear-gradient(to bottom, #F0F5FA, #E6EFFA);
  }
  .el-header, .el-aside, .el-main {
    padding: 0;
    margin: 0;
  }
  </style>